export default "__VITE_ASSET__5fb61dfc__"